<script>
import { httpRequest } from '@v4/http/request';

/**
 * Fetch resources asynchronously and exposes them in the default `v-slot`
 */
export default {
    name: 'FetchData',
    props: {
        /**
         * URL to fetch the data from
         */
        url: {
            type: String,
            default: '',
        },
        /**
         *  HTTP request method. Available values: `GET`, 'POST'
         */
        method: {
            type: String,
            default: 'GET',
            validator(value) {
                return ['GET', 'POST'].includes(value.toUpperCase());
            },
        },
        /**
         * HTTP request body data
         */
        data: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            loading: true,
            response: null,
            error: null,
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.loading = true;

            if (!this.url) {
                this.loading = false;

                return;
            }

            httpRequest({ url: this.url, method: this.method.toUpperCase(), data: this.data })
                .then((response) => {
                    this.response = response;

                    /**
                     * Fired when getting success response
                     *
                     * @event response
                     * @type {object}
                     * @property {object} response - Response data
                     */
                    this.$emit('response', { response: response.data });
                })
                .catch((error) => {
                    this.error = error;

                    /**
                     * Fired when getting error response
                     *
                     * @event response
                     * @type {object}
                     * @property {object} error - Error data
                     */
                    this.$emit('error', { error });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    render(h) {
        if (!this.$scopedSlots.default) {
            return;
        }

        return h(
            'div',
            { class: 'fetch-data' },
            /**
             * @slot Default content
             * @binding {boolean} loading Whether is loading or not
             * @binding {object} error Error response
             * @binding {object} response Successful response
             * @binding {function} fetchData Fetches data again
             */
            this.$scopedSlots.default({
                loading: this.loading,
                error: this.error,
                response: this.response,
                fetchData: this.fetchData,
            })
        );
    },
};
</script>
